import { RouteConfig } from 'vue-router';

const depositRouter: RouteConfig[] = [
  {
    name: 'Deposit',
    path: '/deposit/index',
    component: () =>
      import(
        /* webpackChunkName: "Deposit" */
        '@/views/deposit/index.vue'
      ),
    meta: { title: ' ' },
  },
  {
    name: 'DepositAgreement',
    path: '/deposit/agreement',
    component: () =>
      import(
        /* webpackChunkName: "DepositAgreement" */
        '@/views/deposit/agreement.vue'
      ),
    meta: { title: '保证金金额调整确认函' },
  },
  {
    name: 'DepositResult',
    path: '/deposit/result',
    component: () =>
      import(
        /* webpackChunkName: "DepositResult" */
        '@/views/deposit/result.vue'
      ),
    meta: { title: ' ' },
  },
];

export default depositRouter;
